import { MONTHLY_PLAN_TYPES } from '../components/home/constants';
export var shouldDisableDate = function (planType, day) {
  var isMonthlyPlanType = MONTHLY_PLAN_TYPES.includes(planType);
  // Disable all dates except the 1st of the month for monthly plans
  return isMonthlyPlanType && day.date() !== 1;
};